import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { APPLY_BRANDS } from '@app/utils/constants/apply-brands';

export const brandGuard: CanActivateFn = route => {
  const router = inject(Router);
  const brandParam = route.paramMap.get('brand');

  if (brandParam && APPLY_BRANDS.some(applyBrand => applyBrand.param === brandParam)) {
    return true;
  }

  return router.parseUrl('/apply');
};
